import { invert } from 'lodash-es';
import { CountryUtils } from './country/CountryUtils';
import { TranslationId } from './types/TranslationId';

/**
 * Enum for crop names used throughout the application.
 */
export enum CropName {
  WINTER_WHEAT = 'WINTER_WHEAT',
  DURUM_WHEAT = 'DURUM_WHEAT',
  SPRING_WHEAT = 'SPRING_WHEAT',
  SUGAR_BEET = 'SUGAR_BEET',
  POTATO = 'POTATO',
  OILSEED_RAPE = 'OILSEED_RAPE',
  WINTER_BARLEY = 'WINTER_BARLEY',
  CANOLA = 'CANOLA',
  CORN = 'CORN',
  SWEET_CORN = 'SWEET_CORN',
  SOYBEAN = 'SOYBEAN',
  RICE = 'RICE',
  WINTER_RYE = 'WINTER_RYE',
  OATS = 'OATS',
  COMMON_OAT = 'COMMON_OAT',
  SUNFLOWERS = 'SUNFLOWERS',
  PEANUT = 'PEANUT',
  BROMUS_CATHARTICUS = 'BROMUS_CATHARTICUS',
  BRASSICA_RAPA = 'BRASSICA_RAPA',
  CHICKPEA = 'CHICKPEA',
  DACTYLIS_GLOMERATA = 'DACTYLIS_GLOMERATA',
  GOSSYPIUM_HIRSUTUM = 'GOSSYPIUM_HIRSUTUM',
  LENTILS = 'LENTILS',
  FLAX = 'FLAX',
  LOLIUM_PERENNE = 'LOLIUM_PERENNE',
  LOTUS_CORNICULATUS = 'LOTUS_CORNICULATUS',
  ALFALFA = 'ALFALFA',
  CHICORY = 'CHICORY',
  MELILOTUS_ALBUS = 'MELILOTUS_ALBUS',
  PANICUM_MILIACEUM = 'PANICUM_MILIACEUM',
  DRY_BEANS = 'DRY_BEANS',
  PEAS = 'PEAS',
  SORGHUM_SP = 'SORGHUM_SP',
  TRIFOLIUM_PRATENSE = 'TRIFOLIUM_PRATENSE',
  TRIFOLIUM_REPENS = 'TRIFOLIUM_REPENS',
  THINOPYRUM_ELONGATUM = 'THINOPYRUM_ELONGATUM',
  CHLORIS_GAYANA = 'CHLORIS_GAYANA',
  ERAGROSTIS_CURVULA = 'ERAGROSTIS_CURVULA',
  SCHEDONORUS_ARUNDINACEUS = 'SCHEDONORUS_ARUNDINACEUS',
  LOLIUM_MULTIFLORUM = 'LOLIUM_MULTIFLORUM',
  LOTUS_GLABER = 'LOTUS_GLABER',
  UROCHLOA_MAXIMA = 'UROCHLOA_MAXIMA',
  PASPALUM_DILATATUM = 'PASPALUM_DILATATUM',
  SACCHARUM_HYBRIDS = 'SACCHARUM_HYBRIDS',
  VICIA_SP = 'VICIA_SP',
  GRASSLAND = 'GRASSLAND',
  FOXTAIL_MILLET = 'FOXTAIL_MILLET',
  WINTER_TRITICALE = 'WINTER_TRITICALE',
  SPRING_BARLEY = 'SPRING_BARLEY',
  SPRING_DURUM_WHEAT = 'SPRING_DURUM_WHEAT',
  BROADBEAKED_MUSTARD = 'BROADBEAKED_MUSTARD',
  OIL_SQUASH = 'OIL_SQUASH',
  SQUASH = 'SQUASH',
  WINTER_VETCH = 'WINTER_VETCH',
  CABBAGE = 'CABBAGE',
  CHINESE_CLOVER = 'CHINESE_CLOVER',
  RED_MUNG_BEAN = 'RED_MUNG_BEAN',
  BROCCOLI = 'BROCCOLI',
  CARNATION_CLOVER = 'CARNATION_CLOVER',
  RAPE = 'RAPE',
  ONION = 'ONION',
  LEEK = 'LEEK',
  CARROT = 'CARROT',
  SPRING_RYE = 'SPRING_RYE',
  TRITICUM_SPELTA = 'TRITICUM_SPELTA',
  SPRING_TRITICALE = 'SPRING_TRITICALE',
  WINTER_OAT = 'WINTER_OAT',
  SPRING_OIL_SEED_RAPE = 'SPRING_OIL_SEED_RAPE',
  MUSTARD_SEED = 'MUSTARD_SEED',
  SORGHUM = 'SORGHUM',
  RYE = 'RYE',
  BUCK_WHEAT = 'BUCK_WHEAT',
  HEMP = 'HEMP',
  COMMON_SUGARCANE = 'COMMON_SUGARCANE',
  FODDER_BEET = 'FODDER_BEET',
  BROAD_BEANS = 'BROAD_BEANS',
  COMMON_CORIANDER = 'COMMON_CORIANDER',
  FABA_BEAN = 'FABA_BEAN',
  PHACELIA = 'PHACELIA',
  POPPY_SEED = 'POPPY_SEED',
  COFFEA_ARABICA = 'COFFEA_ARABICA',
  VICIA_SATIVA = 'VICIA_SATIVA',
  PINTO_PEANUT = 'PINTO_PEANUT',
  COMMON_GRAPEVINE = 'COMMON_GRAPEVINE',
  TABLE_GRAPE = 'TABLE_GRAPE',
  KALE = 'KALE',
  SUMMER_BARLEY = 'SUMMER_BARLEY',
  TRITICALE = 'TRITICALE',
  LUPIN = 'LUPIN',
  ASPARAGUS = 'ASPARAGUS',
  QUINOA = 'QUINOA',
  CONGO_GRASS = 'CONGO_GRASS',
  OTHERS = 'OTHERS',
  BERSEEM_CLOVER = 'BERSEEM_CLOVER',
  ESPARSETTE = 'ESPARSETTE',
  SUDANGRAS = 'SUDANGRAS',
  MUNGOBOHNE = 'MUNGOBOHNE',
  SERADELLA = 'SERADELLA',
  BORRETSCH = 'BORRETSCH',
  MARKSTAMMKOHL = 'MARKSTAMMKOHL',
  MALVE = 'MALVE',
  CALENDULA = 'CALENDULA',
  FARBERDISTEL = 'FARBERDISTEL',
  ECHTER_TABAL = 'ECHTER_TABAL',
  CAMELINA = 'CAMELINA',
  SESAMUM = 'SESAMUM',
  SALVIA_HISPANICA = 'SALVIA_HISPANICA',
  AMARANTHUS = 'AMARANTHUS',
  SAFFLOWER = 'SAFFLOWER',
  BRASSICA_CARINATA = 'BRASSICA_CARINATA',
  APPLE = 'APPLE',
  GARLIC = 'GARLIC',
  VITIS_LABRUSCA = 'VITIS_LABRUSCA',
  PEACH = 'PEACH',
  PYRUS_COMMUNIS = 'PYRUS_COMMUNIS',
  PLUM = 'PLUM',
  TOMATO = 'TOMATO',
  PROCESSED_TOMATO = 'PROCESSED_TOMATO',
  CHINESE_CABBAGE = 'CHINESE_CABBAGE',
  SWEET_POTATO = 'SWEET_POTATO',
  GARDEN_LETTUCE = 'GARDEN_LETTUCE',
  GREEN_ONION = 'GREEN_ONION',
  CANARY_GRASS = 'CANARY_GRASS',

  FALLOW = 'FALLOW',
  COVER_CROP = 'COVER_CROP',

  PLANNED = 'PLANNED',
  UNASSIGNED = 'UNASSIGNED',
  NA = 'NA',
}

export enum LicenceName {
  PRO = 'PRO',
  PREMIUM = 'PREMIUM',
  PRO2023 = 'PRO2023',
  PRO2022 = 'PRO2022',
  PREMIUM2022 = 'PREMIUM2022',
  PREMIUM_POTATO = 'PREMIUM_POTATO',
  PREMIUM_WHEAT = 'PREMIUM_WHEAT',
  PREMIUM_WHEAT_BARLEY = 'PREMIUM_WHEAT_BARLEY',
  PREMIUM_WHEAT_BARLEY_OSR = 'PREMIUM_WHEAT_BARLEY_OSR',
}

export class CropUtils {
  static get CROPS() {
    return {
      [CropName.WINTER_WHEAT]: '9b4ee6b2-ae2d-6c9a-af77-08a4b749031f',
      [CropName.DURUM_WHEAT]: '0dc6b6d6-4566-4966-3dcf-4f23722e7832',
      [CropName.SPRING_WHEAT]: 'd6762313-1841-b6a0-dcb1-a94ab311618a',
      [CropName.SUGAR_BEET]: '6c119c74-41ec-8bc5-1b0f-15ff3a913bc0',
      [CropName.POTATO]: '5299afb0-37fd-6ad5-4d1f-65f9668799b9',
      [CropName.OILSEED_RAPE]: '619287cf-c63f-78b5-f563-56342ee09ec2',
      [CropName.WINTER_BARLEY]: 'ec0d0f52-dd71-ebb9-0a39-831768fe4490',
      [CropName.CANOLA]: '21486538-1018-3545-1b27-eef605e51e7f',
      [CropName.CORN]: 'b59fc4c2-7738-ec26-6925-d3041e155180',
      [CropName.SWEET_CORN]: '843fd95e-f187-7627-ac9b-2012e6874df2',
      [CropName.RICE]: 'e54c5e22-94a0-a5ff-34a6-4fe0f8ad1ccc',
      [CropName.SOYBEAN]: '387f0de8-2015-96d2-86cf-f8d7b7151c6c',
      [CropName.WINTER_RYE]: '5c8bb7ea-5b9a-aa5a-2f11-7fdccfc713aa',
      [CropName.OATS]: 'f2970e40-01b4-339d-3de7-5b19f7393703',
      [CropName.COMMON_OAT]: 'dc8bb7f2-0fa9-5ed1-ab53-f52e54a7fed9',
      [CropName.SUNFLOWERS]: 'd086e9f3-ad1c-af18-b8cd-411be5db670b',
      [CropName.PEANUT]: 'a7ca1b71-f1ba-ab55-441c-982f00b2b236',
      [CropName.BROMUS_CATHARTICUS]: '648bfb5b-ce85-f713-7a08-ca8e7c73400e',
      [CropName.BRASSICA_RAPA]: '93d6102c-6f26-646f-3212-24fd150ba94c',
      [CropName.CHICKPEA]: '95ee42ed-c0f8-8551-02c8-f5806b616fce',
      [CropName.DACTYLIS_GLOMERATA]: '38c1d1af-dd99-b283-09e6-220368322cf1',
      [CropName.GOSSYPIUM_HIRSUTUM]: 'f3cba8d9-b818-3ec7-f147-36a332bb30d9',
      [CropName.LENTILS]: 'f2cf30e8-462e-9811-2aab-20c285d605da',
      [CropName.FLAX]: '0ca9b456-f2de-1486-8378-f9643e63413c',
      [CropName.LOLIUM_PERENNE]: '3fe403eb-0775-fc97-c758-b81ab60c0b95',
      [CropName.LOTUS_CORNICULATUS]: '69759c1e-a3fd-556c-43ec-1bb88ac9d1f4',
      [CropName.ALFALFA]: 'b5a17c7c-aed7-6c05-5e05-224f6390f6e4',
      [CropName.CHICORY]: 'ee8be336-d5e3-678a-0018-3d55da5f45f2',
      [CropName.MELILOTUS_ALBUS]: '20032981-bf50-ef16-4da6-58d284d0883d',
      [CropName.PANICUM_MILIACEUM]: '01381ee4-a3f3-e710-690a-e775ac5156e8',
      [CropName.DRY_BEANS]: 'd672cb81-5a86-9177-e412-e8507d1fbc9e',
      [CropName.PEAS]: '0f78171b-b01c-ff3d-2a0f-6c3c4191fcfc',
      [CropName.SORGHUM_SP]: '83cb386e-8e5a-7110-2344-c222a3bd77db',
      [CropName.TRIFOLIUM_PRATENSE]: '1d98d02e-0ae9-9926-5a4c-4152afae5513',
      [CropName.TRIFOLIUM_REPENS]: 'ff3d116c-288c-6b47-1322-d9170f7a14c3',
      [CropName.THINOPYRUM_ELONGATUM]: '625b1e7f-615b-4ab3-4cbc-46f577eb89d5',
      [CropName.CHLORIS_GAYANA]: '18d04cf7-421c-ca1f-aed1-dce2ce74e063',
      [CropName.ERAGROSTIS_CURVULA]: 'c11298f9-ff3e-4a67-17d0-0284edcd133d',
      [CropName.SCHEDONORUS_ARUNDINACEUS]:
        '21e24834-6d4a-d25f-8447-277c42029328',
      [CropName.LOLIUM_MULTIFLORUM]: '3ddb27f7-7377-f4c4-546b-43035e560510',
      [CropName.LOTUS_GLABER]: '35f297de-8dc3-b509-16e9-28a9b69d29e7',
      [CropName.UROCHLOA_MAXIMA]: '0aaa4e8a-db78-c2e8-bf91-ec8805c2dc8b',
      [CropName.PASPALUM_DILATATUM]: '72182a28-b377-203b-10b8-d79787f518ef',
      [CropName.SACCHARUM_HYBRIDS]: '4e409a36-1ca1-ae12-e3e8-91d0f5fd45e1',
      [CropName.VICIA_SP]: '4f7a84be-bf4c-6231-23a5-ac598e0ad985',
      [CropName.GRASSLAND]: '201fbf47-ad3e-3fb9-18b1-de7221ad0ddb',
      [CropName.FOXTAIL_MILLET]: 'dc4670e4-38c9-f5a1-035a-3642cde4d28d',
      [CropName.WINTER_TRITICALE]: '6dbe1df0-11b1-e502-0a3f-1cba5668b02b',
      [CropName.SPRING_BARLEY]: '24197977-623a-6514-d080-3aa170896771',
      [CropName.SPRING_DURUM_WHEAT]: '75844767-cd96-247f-fe97-8025a593caba',
      [CropName.BROADBEAKED_MUSTARD]: '9b1c4b9d-4b2a-4413-42eb-6714262ea2bf',
      [CropName.OIL_SQUASH]: 'e56d6dcf-62f3-b4b7-8736-a06f7f14742e',
      [CropName.SQUASH]: '4abf26b8-1c6d-8065-2b81-2a1d4fe09af2',
      [CropName.WINTER_VETCH]: 'b0ddfc54-a82f-dd92-8116-99532f5d4caf',
      [CropName.CABBAGE]: 'f8e7f640-12b3-8350-9bee-3102de1902e1',
      [CropName.CHINESE_CLOVER]: 'c812b6c1-d38c-b51e-94ce-f19c314d5e8a',
      [CropName.RED_MUNG_BEAN]: '6b97aa21-2ff4-62ab-dad1-df95465fb2c7',
      [CropName.BROCCOLI]: 'c40db4dd-400a-d8da-e8e4-52fe71a01732',
      [CropName.CARNATION_CLOVER]: 'e1ced3a8-a1f5-a88d-c42f-f65a4cbd07f9',
      [CropName.RAPE]: '2615acdb-2ce7-1844-5c6e-02b7e90b8c2d',
      [CropName.ONION]: '754b282d-1b4f-ff98-5a02-c99ea4bd4a93',
      [CropName.LEEK]: '16d8c3a2-9158-686d-f604-ce015a5a9f32',
      [CropName.CARROT]: 'a7117f18-8c3e-0f79-2e74-52f76459db73',
      [CropName.SPRING_RYE]: '2cb3a999-98d8-c3eb-9d1b-a2cc99c1c17d',
      [CropName.TRITICUM_SPELTA]: 'd65fb3b9-faef-7913-c0b5-8629df1bcaa9',
      [CropName.SPRING_TRITICALE]: '859696c5-e133-42a6-d9d4-1fea8610c718',
      [CropName.WINTER_OAT]: '132f12e8-fa52-4e31-7a00-f86eb641a81c',
      [CropName.SPRING_OIL_SEED_RAPE]: 'caf6eb4d-79d3-0761-5fb2-9fec2d6b9aa1',
      [CropName.MUSTARD_SEED]: '9abaf7d8-c0c5-a524-5aeb-73158ded1637',
      [CropName.SORGHUM]: '4c1002b5-d6eb-576a-da99-12df5448dca1',
      [CropName.RYE]: '988e0c6d-f264-0b92-c724-4cc3921504ed',
      [CropName.BUCK_WHEAT]: '418ad89b-e582-3321-bfe5-1ad9b0a0f1c8',
      [CropName.HEMP]: '7fee4284-113a-3b24-7084-4b905cfc4820',
      [CropName.COMMON_SUGARCANE]: '2635d6e9-b581-a717-cf9b-51ad86f443cf',
      [CropName.FODDER_BEET]: 'b1e7feb0-7f5f-9501-f4a1-07913146090b',
      [CropName.BROAD_BEANS]: '9888aece-8c38-3d93-baf0-fc4420853b4d',
      [CropName.COMMON_CORIANDER]: 'e93d8150-33e9-168a-0a4d-1a87f98f487b',
      [CropName.FABA_BEAN]: 'd7ea9789-5fe4-4fd0-9df5-11528e047716',
      [CropName.PHACELIA]: '2fc1d8ad-6b3f-69c4-db9b-7243dc31162d',
      [CropName.POPPY_SEED]: '6af222bf-4414-7584-d146-933ebf3d3926',
      [CropName.COFFEA_ARABICA]: 'c3e44832-b184-c51e-323a-30a99bef4d93',
      [CropName.VICIA_SATIVA]: '38029f68-8038-3536-bac4-11622b13b0df',
      [CropName.PINTO_PEANUT]: '0434d4a3-70c3-47c5-f7da-986252a2b06a',
      [CropName.COMMON_GRAPEVINE]: '99c8e134-40fc-63ab-0af7-9748b51de01f',
      [CropName.TABLE_GRAPE]: 'f6f83572-f0d8-2072-d14d-c338c0dbeae9',
      [CropName.KALE]: '612457d0-9034-b681-7ac5-4d6f44030b40',
      [CropName.SUMMER_BARLEY]: '4766d49b-1ccc-3313-6b05-0135598ed4bc',
      [CropName.TRITICALE]: 'f5e60524-5990-9049-f0a2-c59942d6eb18',
      [CropName.LUPIN]: '92c323a5-d2ce-5c7c-0da0-55d519a557bf',
      [CropName.ASPARAGUS]: '3b3f3648-19ba-db06-2a1a-8f9e0ac3858d',
      [CropName.QUINOA]: '36d2391f-15fd-d4ee-c7c7-ce00a3ac5e84',
      [CropName.CONGO_GRASS]: '6813790e-03fb-dcef-27fb-0efa18318eed',
      [CropName.OTHERS]: '120723ff-2aaa-b8fd-2ec3-5792196684a4',
      [CropName.BERSEEM_CLOVER]: '40444219-8267-4dda-6a69-6a101236528b',
      [CropName.ESPARSETTE]: 'c9a3f5d3-6fb3-dfbb-7153-02fc2269b08b',
      [CropName.SUDANGRAS]: 'babf6029-e6b0-64b4-928f-a2fb0ca4d75f',
      [CropName.MUNGOBOHNE]: '109d3a9d-700e-869c-cdd2-a95caac7b1e7',
      [CropName.SERADELLA]: '5b3415e3-2687-aeda-f497-83885a65ad76',
      [CropName.BORRETSCH]: 'a03454bf-1ba8-719e-3210-034a9504aff0',
      [CropName.MARKSTAMMKOHL]: 'cb833ed6-7ad2-cdda-65c0-c744073dc161',
      [CropName.MALVE]: '77ebab47-0c1b-a5ae-bdd9-3edd47dac02e',
      [CropName.CALENDULA]: '52d12b74-de58-6612-6d1d-202cc7d15247',
      [CropName.FARBERDISTEL]: '2042e4be-ba28-1425-2f06-1d0cb985d797',
      [CropName.ECHTER_TABAL]: 'e0ef8698-f853-7b25-deeb-1cceff572954',
      [CropName.CAMELINA]: '8085e1d8-35f5-2d08-9faa-11d7058e79a4',
      [CropName.SESAMUM]: 'c15dc689-f872-ab0d-759d-7bb2de5a2fe7',
      [CropName.SALVIA_HISPANICA]: '982337f5-37da-d5ff-8c6f-ace34ed91b3a',
      [CropName.AMARANTHUS]: '483bdce0-b51d-3ad0-fe76-31a28bad34c3',
      [CropName.SAFFLOWER]: '8a0ab1e8-d423-def8-f0aa-0dc74a40fb90',
      [CropName.BRASSICA_CARINATA]: '06d1c4d0-b83d-4f9f-0d36-91b24d801780',
      [CropName.APPLE]: '704d63a8-30ca-b390-ff28-3f937e7a1686',
      [CropName.GARLIC]: '4a15f3cc-3bcb-eaa7-d400-92f97557fc1b',
      [CropName.VITIS_LABRUSCA]: '51c13a88-a82a-6a05-0bd9-22f252095595',
      [CropName.PEACH]: '82e30378-5e3f-f606-b4c7-c837a93c617c',
      [CropName.PYRUS_COMMUNIS]: '6d9c4211-69ae-cd81-81ae-c7bc2e88f254',
      [CropName.PLUM]: '7b2817e0-1ab8-a502-5929-e24bc1ce3eb8',
      [CropName.TOMATO]: '4f77544a-3a87-04c4-0d08-3b8b61797a92',
      [CropName.PROCESSED_TOMATO]: 'cbc092f4-a61d-0c9e-5119-77ecfbb6e5c6',
      [CropName.CHINESE_CABBAGE]: 'ba5abb67-8596-8d88-27da-50698154338c',
      [CropName.SWEET_POTATO]: '46c2560e-4e05-97ba-6ac9-2b130df102cd',
      [CropName.GARDEN_LETTUCE]: '0b48a531-56f3-0375-2a81-31345b0a1c8f',
      [CropName.GREEN_ONION]: 'f5f969cc-0469-06b3-c0b0-4d94ee541bec',
      [CropName.CANARY_GRASS]: 'c73a958c-6998-6260-e7a6-8a0267f92d6b',

      [CropName.FALLOW]: 'a5138230-1f39-c7dc-5580-387821bcc183',
      [CropName.COVER_CROP]: '9c828c5e-c880-b06a-46e5-7304a96b328d',

      [CropName.PLANNED]: 'PLANNED',
      [CropName.UNASSIGNED]: 'UNASSIGNED',
      [CropName.NA]: 'NA',
    };
  }

  // DFITE-53932
  static get COLORS() {
    return {
      // main crops + cover/fallow/grassland
      [CropName.CANOLA]: '#9CA819',
      [CropName.COMMON_GRAPEVINE]: '#962663',
      [CropName.COMMON_SUGARCANE]: '#1CE6E6',
      [CropName.CORN]: '#E6B522',
      [CropName.COVER_CROP]: '#E6E6E6',
      [CropName.DURUM_WHEAT]: '#C21734',
      [CropName.FALLOW]: '#333333',
      [CropName.GOSSYPIUM_HIRSUTUM]: '#FFFFFF',
      [CropName.LENTILS]: '#0C6161',
      [CropName.OILSEED_RAPE]: '#D5E622',
      [CropName.PEAS]: '#139E9E',
      [CropName.POTATO]: '#6B5410',
      [CropName.RICE]: '#A89C19',
      [CropName.SOYBEAN]: '#A88519',
      [CropName.SPRING_BARLEY]: '#66E028',
      [CropName.SPRING_WHEAT]: '#611A0C',
      [CropName.SUGAR_BEET]: '#855035',
      [CropName.SUNFLOWERS]: '#E6D522',
      [CropName.TRITICUM_SPELTA]: '#EB5E17',
      [CropName.WINTER_BARLEY]: '#4AA31D',
      [CropName.WINTER_RYE]: '#23C272',
      [CropName.WINTER_WHEAT]: '#126619',
      [CropName.GRASSLAND]: '#8C8C8C',
      [CropName.WINTER_TRITICALE]: '#2284E6',
      [CropName.WINTER_OAT]: '#1961A8',
      [CropName.OATS]: '#103E6B',
      [CropName.COMMON_OAT]: '#2253E6',
      [CropName.SORGHUM]: '#EB8117',
      [CropName.SORGHUM_SP]: '#AD5F11',
      [CropName.FLAX]: '#AC2DE0',
      [CropName.ALFALFA]: '#E02DE0',

      // other crops
      [CropName.PEANUT]: '#C79D1E',
      [CropName.BROMUS_CATHARTICUS]: '#8A6C15',
      [CropName.BRASSICA_RAPA]: '#C7B91E',
      [CropName.CHICKPEA]: '#8A8015',
      [CropName.DACTYLIS_GLOMERATA]: '#6B6410',
      [CropName.LOLIUM_PERENNE]: '#B9C71E',
      [CropName.LOTUS_CORNICULATUS]: '#808A15',
      [CropName.CHICORY]: '#646B10',
      [CropName.MELILOTUS_ALBUS]: '#E61C3D',
      [CropName.PANICUM_MILIACEUM]: '#9E132A',
      [CropName.DRY_BEANS]: '#800F22',
      [CropName.TRIFOLIUM_PRATENSE]: '#610C1A',
      [CropName.TRIFOLIUM_REPENS]: '#17C2C2',
      [CropName.THINOPYRUM_ELONGATUM]: '#0F8080',
      [CropName.CHLORIS_GAYANA]: '#E63D1C',
      [CropName.ERAGROSTIS_CURVULA]: '#C23417',
      [CropName.SCHEDONORUS_ARUNDINACEUS]: '#9E2A13',
      [CropName.LOLIUM_MULTIFLORUM]: '#80220F',
      [CropName.LOTUS_GLABER]: '#611A0C',
      [CropName.UROCHLOA_MAXIMA]: '#58C223',
      [CropName.PASPALUM_DILATATUM]: '#3C8518',
      [CropName.SACCHARUM_HYBRIDS]: '#28E038',
      [CropName.VICIA_SP]: '#23C230',
      [CropName.FOXTAIL_MILLET]: '#1DA329',
      [CropName.SPRING_DURUM_WHEAT]: '#188521',
      [CropName.BROADBEAKED_MUSTARD]: '#126619',
      [CropName.OIL_SQUASH]: '#28E084',
      [CropName.SQUASH]: '#1DA360',
      [CropName.WINTER_VETCH]: '#18854E',
      [CropName.CABBAGE]: '#12663C',
      [CropName.CHINESE_CLOVER]: '#1E72C7',
      [CropName.RED_MUNG_BEAN]: '#154F8A',
      [CropName.BROCCOLI]: '#1E48C7',
      [CropName.CARNATION_CLOVER]: '#193DA8',
      [CropName.RAPE]: '#15328A',
      [CropName.ONION]: '#10276B',
      [CropName.LEEK]: '#2222E6',
      [CropName.CARROT]: '#1E1EC7',
      [CropName.SPRING_RYE]: '#1919A8',
      [CropName.SPRING_TRITICALE]: '#15158A',
      [CropName.SPRING_OIL_SEED_RAPE]: '#10106B',
      [CropName.MUSTARD_SEED]: '#782DE0',
      [CropName.RYE]: '#6727C2',
      [CropName.BUCK_WHEAT]: '#5721A3',
      [CropName.HEMP]: '#471B85',
      [CropName.FODDER_BEET]: '#361466',
      [CropName.BROAD_BEANS]: '#9527C2',
      [CropName.COMMON_CORIANDER]: '#7D21A3',
      [CropName.FABA_BEAN]: '#661B85',
      [CropName.PHACELIA]: '#4E1466',
      [CropName.POPPY_SEED]: '#C227C2',
      [CropName.COFFEA_ARABICA]: '#A321A3',
      [CropName.VICIA_SATIVA]: '#851B85',
      [CropName.PINTO_PEANUT]: '#661466',
      [CropName.TABLE_GRAPE]: '#962663',
      [CropName.KALE]: '#F23DD4',
      [CropName.SUMMER_BARLEY]: '#D435B9',
      [CropName.TRITICALE]: '#B52D9E',
      [CropName.LUPIN]: '#962684',
      [CropName.ASPARAGUS]: '#781E69',
      [CropName.QUINOA]: '#F23D9F',
      [CropName.CONGO_GRASS]: '#D4358B',
      [CropName.OTHERS]: '#B52D77',
      [CropName.BERSEEM_CLOVER]: '#781E4F',
      [CropName.ESPARSETTE]: '#F23D6A',
      [CropName.SUDANGRAS]: '#D4355D',
      [CropName.MUNGOBOHNE]: '#B52D4F',
      [CropName.SERADELLA]: '#962642',
      [CropName.BORRETSCH]: '#781E34',
      [CropName.MARKSTAMMKOHL]: '#B26B47',
      [CropName.MALVE]: '#995C3D',
      [CropName.CALENDULA]: '#70432D',
      [CropName.FARBERDISTEL]: '#5C3725',
      [CropName.ECHTER_TABAL]: '#B27847',
      [CropName.CAMELINA]: '#99673D',
      [CropName.SESAMUM]: '#855A35',
      [CropName.SALVIA_HISPANICA]: '#704C2D',
      [CropName.AMARANTHUS]: '#5C3E25',
      [CropName.SAFFLOWER]: '#B28647',
      [CropName.BRASSICA_CARINATA]: '#99733D',
      [CropName.APPLE]: '#856335',
      [CropName.GARLIC]: '#70542D',
      [CropName.VITIS_LABRUSCA]: '#5C4525',
      [CropName.PEACH]: '#FFCBA4',
      [CropName.PYRUS_COMMUNIS]: '#D4E157',
      [CropName.PLUM]: '#8E4585',
      [CropName.TOMATO]: '#E74C3C',
      [CropName.PROCESSED_TOMATO]: '#E74C3C',
      [CropName.CHINESE_CABBAGE]: '#2E8B57',
      [CropName.SWEET_POTATO]: '#E07B39',
      [CropName.GARDEN_LETTUCE]: '#7CCD7C',
      [CropName.GREEN_ONION]: '#4DBD33',
      [CropName.CANARY_GRASS]: '#A8C256',
    };
  }

  static get LICENCE_UUIDS() {
    return {
      [LicenceName.PRO]: 'b2cf1729-adc4-4eff-9622-37e8dedb5f6c',
      [LicenceName.PREMIUM]: '00afcdc8-1b38-472c-8dd3-4f56e3ac96b9',
      [LicenceName.PRO2023]: '2a6cbf97-d36e-44df-aab9-bc593132dd64',
      [LicenceName.PRO2022]: '848f1a5b-f3c7-4e2c-9e86-5e2764a1fe1d',
      [LicenceName.PREMIUM2022]: '9ee3551b-4455-4317-a481-aecb736944f3',
      [LicenceName.PREMIUM_POTATO]: '519ee555-327e-4282-be41-6d7e72f801e9',
      [LicenceName.PREMIUM_WHEAT]: 'd21249db-9a66-445f-9ae8-df115df1e472',
      [LicenceName.PREMIUM_WHEAT_BARLEY]:
        '49285468-ffca-4d63-bfa4-75d7750b763f',
      [LicenceName.PREMIUM_WHEAT_BARLEY_OSR]:
        '64a2d960-50b4-4ae2-9b6b-ab08bf922924',
    };
  }

  static get CROP_UUIDS(): Record<string, string> {
    return invert(CropUtils.CROPS);
  }

  static get dfIcon(): { [key: string]: string } {
    return {
      [CropName.WINTER_WHEAT]: 'wheat',
      [CropName.DURUM_WHEAT]: 'wheat',
      [CropName.SPRING_WHEAT]: 'wheat',
      [CropName.SUGAR_BEET]: 'sugar-beet',
      [CropName.POTATO]: 'potato',
      [CropName.OILSEED_RAPE]: 'oilseed-rape',
      [CropName.WINTER_BARLEY]: 'barley',
      [CropName.CANOLA]: 'oilseed-rape',
      [CropName.CORN]: 'corn',
      [CropName.SWEET_CORN]: 'corn',
      [CropName.SOYBEAN]: 'soybean',
      [CropName.RICE]: 'rice',
      [CropName.WINTER_RYE]: 'rye',
      [CropName.OATS]: 'oats',
      [CropName.COMMON_OAT]: 'sunflower',
      [CropName.SUNFLOWERS]: 'sunflower',
      [CropName.PEANUT]: 'monkey-nut',
      [CropName.BROMUS_CATHARTICUS]: 'bromus-catharticus',
      [CropName.BRASSICA_RAPA]: 'brassica-rapa',
      [CropName.CHICKPEA]: 'chickpea',
      [CropName.DACTYLIS_GLOMERATA]: 'dactylis-glomerata',
      [CropName.GOSSYPIUM_HIRSUTUM]: 'gossypium-hirsutum',
      [CropName.LENTILS]: 'lentils',
      [CropName.FLAX]: 'flax',
      [CropName.LOLIUM_PERENNE]: 'lolium-perenne',
      [CropName.LOTUS_CORNICULATUS]: 'lotus-corniculatus',
      [CropName.ALFALFA]: 'alfalfa',
      [CropName.CHICORY]: 'crop',
      [CropName.MELILOTUS_ALBUS]: 'melilotus-albus',
      [CropName.PANICUM_MILIACEUM]: 'panicum-miliaceum',
      [CropName.DRY_BEANS]: 'dry-beans',
      [CropName.PEAS]: 'peas',
      [CropName.SORGHUM_SP]: 'sorghum-sp',
      [CropName.TRIFOLIUM_PRATENSE]: 'trifolium-pratense',
      [CropName.TRIFOLIUM_REPENS]: 'trifolium-repens',
      [CropName.THINOPYRUM_ELONGATUM]: 'thinopyrum-elongatum',
      [CropName.CHLORIS_GAYANA]: 'chloris-gayana',
      [CropName.ERAGROSTIS_CURVULA]: 'eragrostis-curvula',
      [CropName.SCHEDONORUS_ARUNDINACEUS]: 'schedonorus-arundinaceus',
      [CropName.LOLIUM_MULTIFLORUM]: 'lolium-multiflorum',
      [CropName.LOTUS_GLABER]: 'lotus-glaber',
      [CropName.UROCHLOA_MAXIMA]: 'urochloa-maxima',
      [CropName.PASPALUM_DILATATUM]: 'paspalum-dilatatum',
      [CropName.SACCHARUM_HYBRIDS]: 'saccharum-hybrids',
      [CropName.VICIA_SP]: 'vicia-sp',
      [CropName.GRASSLAND]: 'grassland',
      [CropName.FOXTAIL_MILLET]: 'foxtail-millet',
      [CropName.WINTER_TRITICALE]: 'winter-triticale',
      [CropName.SPRING_BARLEY]: 'barley',
      [CropName.SPRING_DURUM_WHEAT]: 'wheat',
      [CropName.BROADBEAKED_MUSTARD]: 'crop',
      [CropName.OIL_SQUASH]: 'oil-squash',
      [CropName.SQUASH]: 'oil-squash',
      [CropName.WINTER_VETCH]: 'crop',
      [CropName.CABBAGE]: 'crop',
      [CropName.CHINESE_CLOVER]: 'crop',
      [CropName.RED_MUNG_BEAN]: 'crop',
      [CropName.BROCCOLI]: 'crop',
      [CropName.CARNATION_CLOVER]: 'crop',
      [CropName.RAPE]: 'oilseed-rape',
      [CropName.ONION]: 'crop',
      [CropName.LEEK]: 'crop',
      [CropName.CARROT]: 'crop',
      [CropName.ASPARAGUS]: 'crop',
      [CropName.QUINOA]: 'crop',
      [CropName.CONGO_GRASS]: 'crop',
      [CropName.SPRING_RYE]: 'rye',
      [CropName.TRITICUM_SPELTA]: 'wheat',
      [CropName.SPRING_TRITICALE]: 'winter-triticale',
      [CropName.TRITICALE]: 'winter-triticale',
      [CropName.WINTER_OAT]: 'oats',
      [CropName.SPRING_OIL_SEED_RAPE]: 'oilseed-rape',
      [CropName.MUSTARD_SEED]: 'crop',
      [CropName.SORGHUM]: 'sorghum-sp',
      [CropName.RYE]: 'rye',
      [CropName.BUCK_WHEAT]: 'wheat',
      [CropName.HEMP]: 'crop',
      [CropName.COMMON_SUGARCANE]: 'sugarcane',
      [CropName.FODDER_BEET]: 'sugar-beet',
      [CropName.BROAD_BEANS]: 'beans',
      [CropName.COMMON_CORIANDER]: 'crop',
      [CropName.FABA_BEAN]: 'beans',
      [CropName.PHACELIA]: 'crop',
      [CropName.POPPY_SEED]: 'crop',
      [CropName.COFFEA_ARABICA]: 'crop',
      [CropName.VICIA_SATIVA]: 'crop',
      [CropName.PINTO_PEANUT]: 'crop',
      [CropName.COMMON_GRAPEVINE]: 'grapes',
      [CropName.TABLE_GRAPE]: 'grapes',
      [CropName.LUPIN]: 'lupines',
      [CropName.OTHERS]: 'crop',
      [CropName.BERSEEM_CLOVER]: 'crop',
      [CropName.ESPARSETTE]: 'crop',
      [CropName.SUDANGRAS]: 'crop',
      [CropName.MUNGOBOHNE]: 'crop',
      [CropName.SERADELLA]: 'crop',
      [CropName.BORRETSCH]: 'crop',
      [CropName.MARKSTAMMKOHL]: 'crop',
      [CropName.MALVE]: 'crop',
      [CropName.CALENDULA]: 'crop',
      [CropName.FARBERDISTEL]: 'crop',
      [CropName.ECHTER_TABAL]: 'crop',
      [CropName.CAMELINA]: 'crop',
      [CropName.SESAMUM]: 'crop',
      [CropName.SALVIA_HISPANICA]: 'crop',
      [CropName.AMARANTHUS]: 'crop',
      [CropName.SAFFLOWER]: 'crop',
      [CropName.BRASSICA_CARINATA]: 'crop',
      [CropName.APPLE]: 'crop',
      [CropName.GARLIC]: 'crop',
      [CropName.VITIS_LABRUSCA]: 'crop',
      [CropName.PEACH]: 'crop',
      [CropName.PYRUS_COMMUNIS]: 'crop',
      [CropName.PLUM]: 'crop',
      [CropName.TOMATO]: 'tomato',
      [CropName.PROCESSED_TOMATO]: 'tomato',
      [CropName.CHINESE_CABBAGE]: 'crop',
      [CropName.SWEET_POTATO]: 'crop',
      [CropName.GARDEN_LETTUCE]: 'crop',
      [CropName.GREEN_ONION]: 'crop',
      [CropName.CANARY_GRASS]: 'crop',

      [CropName.FALLOW]: 'crop-dotted-line',
      [CropName.COVER_CROP]: 'crop-arrow-clockwise',

      [CropName.PLANNED]: 'datecalendar-plant',
      [CropName.UNASSIGNED]: 'sun-field',
      [CropName.NA]: 'crop',
    };
  }

  // TODO: move priorities to the crop configuration service
  static get priority(): { [key: string]: number } {
    return {
      [CropName.WINTER_WHEAT]: 1,
      [CropName.DURUM_WHEAT]: 2,
      [CropName.SPRING_WHEAT]: 11,
      [CropName.SOYBEAN]: 9,
      [CropName.GOSSYPIUM_HIRSUTUM]: 10,
      [CropName.POTATO]: 6,
      [CropName.SUGAR_BEET]: 7,
      [CropName.WINTER_BARLEY]: 3,
      [CropName.OILSEED_RAPE]: 5,
      [CropName.CORN]: 8,
      [CropName.CANOLA]: 4,
      [CropName.RICE]: 12,
      [CropName.WINTER_RYE]: 13,
      [CropName.NA]: 100,
      [CropName.COVER_CROP]: 996,
      [CropName.FALLOW]: 997,
      [CropName.PLANNED]: 998,
      [CropName.UNASSIGNED]: 999,
    };
  }

  static getTypeNames(crops: { uuid: string; name: string }[]) {
    const uuidTypeDic = CropUtils.CROP_UUIDS;

    const typeNameDic: Record<string, any> = {};

    crops.forEach((crop) => {
      if (uuidTypeDic[crop.uuid]) {
        typeNameDic[uuidTypeDic[crop.uuid]] = crop.name;
      }
    });

    return typeNameDic;
  }
}

export const getCrop = (cropUuid: string, country?: string) => {
  const isCommonGrapevine = cropUuid === CropUtils.CROPS.COMMON_GRAPEVINE;
  const isTableGrape = cropUuid === CropUtils.CROPS.TABLE_GRAPE;

  const nonTimingCropsPerCountry = {
    [CountryUtils.COUNTRY.JAPAN]: [
      CropName.CABBAGE,
      CropName.ONION,
      CropName.CHINESE_CLOVER,
      CropName.RED_MUNG_BEAN,
      CropName.BROCCOLI,
      CropName.WINTER_VETCH,
      CropName.CARROT,
      CropName.CARNATION_CLOVER,
      CropName.BUCK_WHEAT,
      CropName.RAPE,
      CropName.POTATO,
      CropName.SUGAR_BEET,
      CropName.DRY_BEANS,
      CropName.CORN,
    ],
  };
  return {
    isWinterWheat: cropUuid === CropUtils.CROPS.WINTER_WHEAT,
    isTriticumSpelta: cropUuid === CropUtils.CROPS.TRITICUM_SPELTA,
    isWinterBarley: cropUuid === CropUtils.CROPS.WINTER_BARLEY,
    isSpringBarley: cropUuid === CropUtils.CROPS.SPRING_BARLEY,
    isDurumWheat: cropUuid === CropUtils.CROPS.DURUM_WHEAT,
    isOilseedRape: cropUuid === CropUtils.CROPS.OILSEED_RAPE,
    isRice: cropUuid === CropUtils.CROPS.RICE,
    isSoybean: cropUuid === CropUtils.CROPS.SOYBEAN,
    isPotato: cropUuid === CropUtils.CROPS.POTATO,
    isFallow: cropUuid === CropUtils.CROPS.FALLOW,
    isCorn: cropUuid === CropUtils.CROPS.CORN,
    isCoverCrop: cropUuid === CropUtils.CROPS.COVER_CROP,
    isSugarBeet: cropUuid === CropUtils.CROPS.SUGAR_BEET,
    isSugarCane: cropUuid === CropUtils.CROPS.COMMON_SUGARCANE,
    isHybridSugarCane: cropUuid === CropUtils.CROPS.SACCHARUM_HYBRIDS,
    isSunflower: cropUuid === CropUtils.CROPS.SUNFLOWERS,
    isDryBean: cropUuid === CropUtils.CROPS.DRY_BEANS,
    isLentils: cropUuid === CropUtils.CROPS.LENTILS,
    isPeas: cropUuid === CropUtils.CROPS.PEAS,
    isCotton: cropUuid === CropUtils.CROPS.GOSSYPIUM_HIRSUTUM,
    isCommonGrapevine,
    isTableGrape,
    isGrape: isCommonGrapevine || isTableGrape,
    isCanola: cropUuid === CropUtils.CROPS.CANOLA,
    isSpringRye: cropUuid === CropUtils.CROPS[CropName.SPRING_RYE],
    isSorghum: cropUuid === CropUtils.CROPS[CropName.SORGHUM],
    isOats: cropUuid === CropUtils.CROPS[CropName.OATS],
    isCommonOat: cropUuid === CropUtils.CROPS[CropName.COMMON_OAT],
    isSpringWheat: cropUuid === CropUtils.CROPS[CropName.SPRING_WHEAT],
    isRye: cropUuid === CropUtils.CROPS[CropName.RYE],
    isWinterRye: cropUuid === CropUtils.CROPS[CropName.WINTER_RYE],
    isGrassland: cropUuid === CropUtils.CROPS[CropName.GRASSLAND],
    isPeanut: cropUuid === CropUtils.CROPS[CropName.PEANUT],
    isTomato: cropUuid === CropUtils.CROPS[CropName.TOMATO],
    isProcessedTomato: cropUuid === CropUtils.CROPS[CropName.PROCESSED_TOMATO],
    isNonTiming: (country && nonTimingCropsPerCountry[country]
      ? nonTimingCropsPerCountry[country]
      : []
    ).includes(CropUtils.CROP_UUIDS[cropUuid] as CropName),
  };
};

export const GRAPE_CROP_UUIDS = [
  CropUtils.CROPS[CropName.COMMON_GRAPEVINE],
  CropUtils.CROPS[CropName.TABLE_GRAPE],
];

export const isGrapeCrop = (cropUuid: string | undefined | null): boolean =>
  GRAPE_CROP_UUIDS.includes(cropUuid || '');

export const customCropTranslationKey = (
  cropUuid: string | undefined | null,
  key: TranslationId,
): TranslationId => {
  const CROP_TRANSLATION_OVERRIDES = {
    [CropUtils.CROPS[CropName.COMMON_GRAPEVINE]]: {
      'general.variety': 'general.variety_grapes',
    },
    [CropUtils.CROPS[CropName.TABLE_GRAPE]]: {
      'general.variety': 'general.variety_grapes',
    },
  };
  return CROP_TRANSLATION_OVERRIDES[cropUuid || '']?.[key] || key;
};
